"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestNoRefreshToken = exports.axiosInstance = void 0;
var tslib_1 = require("tslib");
var axios_1 = tslib_1.__importDefault(require("axios"));
var interceptors_1 = require("../interceptors");
exports.axiosInstance = axios_1.default.create();
exports.axiosInstance.interceptors.request.use(interceptors_1.requestInterceptor, interceptors_1.errorRequestInterceptor);
exports.axiosInstance.interceptors.response.use(interceptors_1.responseInterceptorToken, interceptors_1.errorResponseInterceptorToken);
exports.requestNoRefreshToken = {
    get: function (endpoint) { return exports.axiosInstance.get(endpoint).catch(function (e) { return Promise.reject(e); }); },
    post: function (endpoint, body) { return exports.axiosInstance.post(endpoint, body).catch(function (e) { return Promise.reject(e); }); },
    delete: function (endpoint, body) { return exports.axiosInstance.delete(endpoint, { data: body }).catch(function (e) { return Promise.reject(e); }); },
    put: function (endpoint, body) { return exports.axiosInstance.put(endpoint, body).catch(function (e) { return Promise.reject(e); }); },
    patch: function (endpoint, body) { return exports.axiosInstance.patch(endpoint, body).catch(function (e) { return Promise.reject(e); }); }
};
//# sourceMappingURL=requestNoRefreshToken.js.map